import { Injectable } from '@angular/core';
import { CommonChartmoduleService } from '../../../Services/common-chartmodule.service';
import { Observable, map } from 'rxjs';
import { SnapshotService } from '../../../Services/snapshot.service';

@Injectable({
  providedIn: 'root',
})
export class UniqueChartService {
  constructor(private commonchartmodules: CommonChartmoduleService, private _configService: SnapshotService) { }
  allowAnimation: any = false;
  // color: string[] = [
  //   '#9BC5E5', '#D5BCE4', '#F9C099', '#FF97A8', '#A6E2D7',
  //   '#BDE6BD', '#BFE1FD', '#F4E4B3', '#CD978B', '#EAC4D5',
  //   '#FFCC99', '#6699CC', '#FF9999', '#66CCCC', '#FF9966',
  //   '#99CC66', '#FF99CC', '#CCCC99', '#FF9966', '#FFCC66',
  //   '#99CC99', '#FFCC00', '#99CCFF', '#FF6666', '#CCCC66'
  // ];
  // color: string[] = [
  //   "#0255cc", "#00b6ff", "#00e5ba", "#9ee900",
  //   "#00b600", "#2f6d2f", "#802ab7", "#c700d3",
  //   "#eb0064", "#eb0064", "#fedb00", "#847b4f",
  //   "#83c4b6", "#4d839e", "#aa91c4", "#f8ac8f",
  //   "#f2cf61", "#647032", "#4e4376", "#5a6670",
  //   "#003a5d", "#2d7f6f", "#453635", "#b75553",
  //   "#b8aaa2", "#ebdec5", "#c4c5c9", "#ddc2b7",
  //   "#d6ae7b", "#492a07"
  // ];
  color:string[]=this.commonchartmodules.color1;
  // color: string[] = [
  //   "#9bc5e5",
  //   "#d5bce4",
  //   "#ff97a8",
  //   "#a7e2d7",
  //   "#ffcc66",
  //   "#ff9966",
  //   "#6799cc",
  //   "#cdcc66",
  //   "#f4e4b3",
  //   "#47b7ae",
  //   "#f9c099",
  //   "#7fb6c6",
  //   "#2c70a3",
  //   "#d6a365",
  //   "#802ab7",
  //   "#00b6ff",
  //   "#417f54",
  //   "#bf5c9e",
  //   "#62849b",
  //   "#e5ce85",
  //   "#ae3875",
  //   "#6750a4",
  //   "#798987",
  //   "#b2f9ee",
  //   "#dd8340",
  //   "#2d97a5",
  //   "#bd78ef",
  //   "#af7f4f",
  //   "#7f5aa3",
  //   "#5c752d"
  // ];
  linearGradients: any = this.color.map((color, index) => ({
    linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
    stops: [
      [0, '#FFFFFF'],
      [1, color.replace(/[^,]+(?=\))/, '0.1')], // Change the alpha to 0.1 for the second color stop
    ],
  }));
  linearGradients1 = this.color.map((color, index) => {
    const darkerShade = this.getDarkerShade(color);
    return {
      darkerShade: darkerShade,
      linearGradient: { x1: 0.4, x2: 0.5, y1: 0, y2: 0 },
      stops: [
        [0, color],
        [1, darkerShade]
      ]
    };
  });
  generateLinearGradient(color: string): any {
    const darkerShade = this.getDarkerShade(color); // Assuming you have a getDarkerShade function
    return {
      darkerShade: darkerShade,
      linearGradient: { x1: 0.4, x2: 0.5, y1: 0, y2: 0 },
      stops: [
        [0, color],
        [1, darkerShade]
      ]
    };
  }
  properties: any;
  colorIndex = 0;
  index = 0;
  textfont = 'KantarBrown-Regular';
  colors = ['#C1E1F3', '#00B0F0', '#B487CF', '#FF637C', '#00AC8B', '#EE9B72', '#D1A292', '#FFC000'];
  upwardTriangle = '&#9650';
  patterns = ['url(#pattern1)'];
  pattern1 = ['url(#pattern1)', 'url(#pattern2)'];
  downwardTriangle = '\u25BC';
  highSignificance = 'green';
  lowSignificance = 'red';
  samplesizeconstant: number = 9000;
  shadowColor = 'rgba(0, 0, 0, 0.5)';
  darkThemeBackgroundColor = 'black';
  defaultThemeBackgroundColor = 'white';
  darkThemeTextColor = 'white';
  defaultThemeTextColor = 'black';
  transparentBackground = 'transparent';
  samplesizeConstantValue = 9000;
  darkThemeShadowColor = 'white';
  updatedCategories = [
    { name: 'Brand 1', image: 'https://img.freepik.com/premium-vector/highly-detailed-vietnam-map-with-borders-isolated-background_599062-8131.jpg' },
    { name: 'Brand 2', image: 'https://d2gg9evh47fn9z.cloudfront.net/800px_COLOURBOX7783047.jpg' },
    { name: 'Brand 3', image: 'https://th.bing.com/th/id/OIP.gxQmRFM-PSHbekk72mukxwHaH_?rs=1&pid=ImgDetMain' },
    { name: 'Brand 4', image: 'https://th.bing.com/th/id/R.4abe7f8a1272b46cb5d1e67d4341b6ec?rik=lW0lyg9V5L%2b7UQ&riu=http%3a%2f%2fwww.mapsof.net%2fuploads%2fstatic-maps%2feuropecontour.png&ehk=aDTomnr7%2bgplizpCBegO2ztJrXsGolh7sWqvGkqOQAI%3d&risl=&pid=ImgRaw&r=0' },
    { name: 'Brand 5', image: 'https://media.istockphoto.com/vectors/black-silhouette-country-borders-map-of-india-on-white-background-of-vector-id955286158?k=6&m=955286158&s=170667a&w=0&h=zeBvYe1ttcA8HTslBhAfLRfzS0q2D3o7LQ9Jtp8ift4=' },
    { name: 'Brand 6', image: 'https://th.bing.com/th/id/OIP.xB_qm1E9-36RTaYXsankpgAAAA?rs=1&pid=ImgDetMain' },
    { name: 'Brand 7', image: 'https://th.bing.com/th/id/OIP.Goh-tNxcyXD550sCNWLfWwHaFu?rs=1&pid=ImgDetMain' },
    { name: 'Brand 8', image: 'https://media.istockphoto.com/vectors/black-map-of-africa-vector-id538983577?k=6&m=538983577&s=170667a&w=0&h=kNULQNQDiGAGXAHDgQktQZlmDx96bqip3Eb-5Z-z6sA=' },
    { name: 'Brand 9', image: 'https://media.istockphoto.com/vectors/vector-map-of-japan-with-high-details-vector-id522130269?k=6&m=522130269&s=612x612&w=0&h=YaRe4yUW_zZo81B4zWEUqqxHP23eJaeQubWgJA6LGzc=' },
  ];

  plotBandsColor = 'white';

  plotBandsColorDark = '#333';
  plotBandsColor2 = '#DCDCDC';
  plotBandsColorDark2 = '#4f4f4f';


  plot = [
    { color: this.plotBandsColor, from: -0.3, to: 0.3 },
    { color: this.plotBandsColor2, from: 0.7, to: 1.3 },
    { color: this.plotBandsColor, from: 1.7, to: 2.3 },
    { color: this.plotBandsColor2, from: 2.7, to: 3.3 },
    { color: this.plotBandsColor, from: 3.7, to: 4.3 },
    { color: this.plotBandsColor2, from: 4.7, to: 5.3 },
    { color: this.plotBandsColor, from: 5.7, to: 6.3 },
    { color: this.plotBandsColor2, from: 6.7, to: 7.3 },
    { color: this.plotBandsColor, from: 7.7, to: 8.3 },
    { color: this.plotBandsColor2, from: 8.7, to: 9.3 },

  ];
  plotDark = [
    { color: this.plotBandsColorDark2, from: -0.3, to: 0.3 },
    { color: this.plotBandsColorDark, from: 0.7, to: 1.3 },
    { color: this.plotBandsColorDark2, from: 1.7, to: 2.3 },
    { color: this.plotBandsColorDark, from: 2.7, to: 3.3 },
    { color: this.plotBandsColorDark2, from: 3.7, to: 4.3 },
    { color: this.plotBandsColorDark, from: 4.7, to: 5.3 },
    { color: this.plotBandsColorDark2, from: 5.7, to: 6.3 },
    { color: this.plotBandsColorDark, from: 6.7, to: 7.3 },
    { color: this.plotBandsColorDark2, from: 7.7, to: 8.3 },
    { color: this.plotBandsColorDark, from: 8.7, to: 9.3 },

  ];
  plot2 = [
    { color: this.plotBandsColor, from: -0.5, to: 0.3 },
    { color: this.plotBandsColor2, from: 0.6, to: 1.4 },
    { color: this.plotBandsColor, from: 1.6, to: 2.4 },
    { color: this.plotBandsColor2, from: 2.6, to: 3.4 },
    { color: this.plotBandsColor, from: 3.6, to: 4.4 },

  ];
  plot2Dark = [
    { color: this.plotBandsColorDark, from: -0.5, to: 0.3 },
    { color: this.plotBandsColorDark2, from: 0.6, to: 1.4 },
    { color: this.plotBandsColorDark, from: 1.6, to: 2.4 },
    { color: this.plotBandsColorDark2, from: 2.6, to: 3.4 },
    { color: this.plotBandsColorDark, from: 3.6, to: 4.4 },

  ];
  linearGradientCombination: any = this.colors.map((color, index) => ({
    linearGradient: {
      x1: 0.4,
      x2: 0.5,
      y1: 0,
      y2: 0
    },
    stops: [
      [0, 'rgba(255, 183, 183, 1)'], // Light red (start color)
      [1, 'rgba(255, 0, 0, 1)']
    ]
  }));
  linearGradient: any = this.colors.map((color, index) => {
    const darkerShade = this.getDarkerShade(color);
    return {
      darkerShade: darkerShade,
      linearGradient: { x1: 0.4, x2: 0.5, y1: 0, y2: 0 },
      stops: [
        [0, color],
        [1, darkerShade]
      ]
    };
  });

  mapusadata = ['us-ma', 'us-wa', 'us-ca', 'us-or', 'us-wi', 'us-me', 'us-mi', 'us-nv', 'us-nm', 'us-co', 'us-wy', 'us-ks', 'us-ne',
    'us-ok', 'us-mo', 'us-il', 'us-in', 'us-vt', 'us-ar', 'us-tx', 'us-oh', 'us-tn', 'us-wv', 'us-dc', 'us-la', 'us-fl', 'us-ga', 'us-sc',
    'us-mn', 'us-mt', 'us-nd', 'us-az', 'us-ut', 'us-hi', 'us-ak', 'us-ri', 'us-al', 'us-ms', 'us-nc', 'us-va', 'us-ia', 'us-md', 'us-de',
    'us-pa', 'us-nj', 'us-ny', 'us-id', 'us-sd', 'us-ct', 'us-nh', 'us-ky'];
  excludedWords = ['is', 'the', 'and', 'a', 'in', 'of', 'for', 'an', 'from', 'it'];

  getDarkerShade(color: any) {
    const darkenFactor = 0.7; // Adjust this factor for a darker shade
    const rgb = color.substring(1); // Remove the '#' from the color
    const r = parseInt(rgb.substring(0, 2), 16);
    const g = parseInt(rgb.substring(2, 4), 16);
    const b = parseInt(rgb.substring(4, 6), 16);
    const darkerR = Math.round(r * darkenFactor);
    const darkerG = Math.round(g * darkenFactor);
    const darkerB = Math.round(b * darkenFactor);
    return `#${darkerR.toString(16).padStart(2, '0')}${darkerG.toString(16).padStart(2, '0')}${darkerB.toString(16).padStart(2, '0')}`;
  }

  patternfunction(ispattern: boolean, chartproperties: any) {
    chartproperties['showPattern'] = ispattern;
  }
  commonfunction(event: any, checkboxchecked: any, chartproperties: any) {
    switch (checkboxchecked) {
      case 'Dark Theme': {
        event.target.classList.toggle('checked')
          ? (chartproperties['darkTheme'] = true)
          : (chartproperties['darkTheme'] = false);
        break;
      }
      case 'Axis Image': {
        event.target.classList.toggle('checked')
          ? (chartproperties['axisImage'] = true)
          : (chartproperties['axisImage'] = false);
        break;
      }
      case 'Shadow#':
      case 'Shadow': {
        event.target.classList.toggle('checked')
          ? (chartproperties['shadow'] = true)
          : (chartproperties['shadow'] = false);
        break;
      }
      case 'Gradient Bar Color#':
      case 'Gradient Bar Color': {
        event.target.classList.toggle('checked')
          ? (chartproperties['gradientBarColor'] = true)
          : (chartproperties['gradientBarColor'] = false);
        break;
      }
      case 'Legend Position : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['legendPosition'] = value;
        break;
      }

      case 'Data Label : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['showDataLabel'] =
          value == 'disable' ? false : true;
        break;
      }

      case 'Legend : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['showLegend'] =
          value == 'disable' ? false : true;
        break;
      }
      case 'Border': {
        chartproperties['border'] = event.target.classList.toggle('checked');
        break;
      }
      case 'Data Label Property# : ':
      case 'Data Label Property : ': {
        chartproperties['datalabelStyle'] = event.target.value;
        break;
      }
      case 'Data Label Color# : ':
      case 'Data Label Color : ': {
        chartproperties['dataLabelColor'] = event.target.value;
        break;
      }
      case 'Marker Style : ': {
        chartproperties['markerStyle'] = event.target.value;
        break;
      }
      case 'Connector': {
        chartproperties['connector'] = event.target.classList.toggle('checked');
        break;
      }
      case 'Chart Title Position : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['chartTitlePosition'] = value;
        break;
      }

      case "ToolTip Style# : ": {
        chartproperties['toolTipStyle'] = event.target.value;
        break
      }

      case "ToolTip Style : ": {
        chartproperties['toolTipStyle'] = event.target.value;
        break
      }

      case "PlotLine Style : ": {
        chartproperties['plotLineStyle'] = event.target.value;

        break
      }

      case "Median Dash Style# : ": {
        chartproperties['medianDashStyle'] = event.target.value;

        break
      }

      case 'Data Label Format# : ':
      case 'Data Label Format : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        if (value == 'percentage') {
          chartproperties['dataLabelFormat'] = true;
        } else {
          chartproperties['dataLabelFormat'] = false;
        }
        break;
      }

      case 'Data Label Size# : ':
        chartproperties.dataLabelSize = event.target.value;
        break;

      case 'GridLines': {
        chartproperties['gridlines'] = event.target.classList.toggle('checked');
        break;
      }

      case 'PlotBands#': {
        chartproperties['plotBands'] = event.target.classList.toggle('checked');
        break;
      }

      case 'Data Label Position : ': {
        chartproperties['dataLabelPosition'] = event.target.value;
        break;
      }

      case 'Horizontal Error Bar': {
        chartproperties['horizontalErrorBar'] = event.target.classList.toggle('checked');
        break;
      }

      case 'Pattern': {
        chartproperties['showPattern'] = event.target.checked;
        break;
      }

      case 'Connector Style : ': {
        chartproperties['connectorStyle'] = event.target.value;
        break;
      }

      case 'Marker Line Style : ': {
        chartproperties['connectorStyle'] = event.target.value;
        break;
      }

      case 'Layout# : ': {
        chartproperties['layoutAlgorithm'] = event.target.value;
        break;
      }

      case 'Chart Style : ': {
        chartproperties['chartStyle'] = event.target.value;
        break;
      }

      case 'Data Label Overlap# : ':
      case "Data Label Overlap": {
        chartproperties.dataLabelOverlap = event.target.checked ? true : false;
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties.dataLabelOverlap = value == 'enable' ? true : false;
        break;
      }

      case 'Marker Style : ':
        chartproperties.markerStyle = event.target.value;
        break;

      case 'Line Style : ':
        chartproperties.gridLineDashStyle = event.target.value;
        break;

      case 'Data Label Size# : ':
        chartproperties.dataLabelSize = event.target.value;
        break;

      case "Data from : ": {
        chartproperties['structure'] = event.target.value;

        break;
      }

      case "LineWidth": {
        chartproperties.lineWidthDna = event.target.value;
        break;
      }
    }
  }
  customizationService() {
    let custom: any = [
      { customization: 'Dark Theme', func: 'commonfunc', inputType: 'checkbox', value: 'Dark' },
      { customization: 'GridLines', func: 'commonfunc', inputType: 'checkbox', value: 'gridLines' },

      { customization: 'Shadow', func: 'commonfunc', inputType: 'checkbox', value: 'Shadow' },
      { customization: 'Gradient Bar Color', func: 'commonfunc', inputType: 'checkbox' },
      { customization: 'Hide Axis', func: 'commonfunc', inputType: 'checkbox', value: 'Hide Axis' },
      { customization: 'Spline', func: 'commonfunc', inputType: 'checkbox' },
      { customization: 'Axis Image', func: 'commonfunc', inputType: 'checkbox' },
      {
        customization: 'Axis Label Orientation : ', func: 'commonfunc', inputType: 'images', options: [
          { value: 'horizontal', label: 'Horizontal', selected: true, imgClassName: 'axisHorizontal', selectedImgClassName: 'axisHorizontalSelected' },
          { value: 'vertical', label: 'Vertical', selected: false, imgClassName: 'axisVertical', selectedImgClassName: 'axisVerticalSelected' },
          { value: 'angled', label: 'Angled', selected: false, imgClassName: 'axisdiagonalRight', selectedImgClassName: 'axisdiagonalRightSelected' },
          { value: 'diagonal', label: 'Diagonal', selected: false, imgClassName: 'axisAngled', selectedImgClassName: 'axisAngledSelected' },
        ]
      },
      {
        customization: 'ToolTip Style# : ', func: 'commonfunc', inputType: 'dropdown', options: [
          { value: 'default', label: 'Default' },

          { value: 'style1', label: 'Style1' },
        ]
      },
      {
        customization: 'Marker : ', func: 'commonfunc', inputType: 'dropdown', options: [
          { value: 'disable', label: 'Disable' },
          { value: 'enable', label: 'Enable' },

        ]
      },
      {
        customization: 'Marker Style : ', func: 'commonfunc', inputType: 'dropdown', options: [

          { value: 'circle', label: 'Circle' },
          { value: 'square', label: 'Square' },
          { value: 'diamond', label: 'Diamond' },
          { value: 'triangle', label: 'Triangle' }
        ]
      },
      {
        customization: 'Chart Title Position : ', func: 'commonfunc', inputType: 'images', options: [
          { value: 'left', label: 'Left', selected: true, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: false, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ]
      },
      {
        customization: 'Legend : ', func: 'commonfunc', inputType: 'images', options: [
          { value: 'disable', label: 'Disable', selected: true, imgClassName: 'legendDisable', selectedImgClassName: 'legendDisableSelected' },
          { value: 'enable', label: 'Enable', selected: false, imgClassName: 'legendEnable', selectedImgClassName: 'legendEnableSelected' },

        ]
      },
      {
        customization: 'Legend Position : ', func: 'commonfunc', inputType: 'images', options: [

          { value: 'left', label: 'Left', selected: true, imgClassName: 'legendLeft', selectedImgClassName: 'legendLeftSelected' },
          { value: 'bottom', label: 'Bottom', selected: false, imgClassName: 'legendBottom', selectedImgClassName: 'legendBottomSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'legendRight', selectedImgClassName: 'legendRightSelected' },  // Add this option for 'Right'
        ]
      },
      {
        customization: 'Data Label : ', func: 'commonfunc', inputType: 'toggle', options: [

          { value: 'disable', label: 'Off', selected: true },
          { value: 'enable', label: 'On', selected: false },

        ]
      },
      {
        customization: 'Data Label Format : ', func: 'commonfunc', inputType: 'images', options: [
          { value: 'number', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ]
      },
      {
        customization: 'Data Label Property : ', func: 'commonfunc', inputType: 'dropdown', options: [
          { value: 'datalabel', label: 'Default ' },
          { value: 'change', label: 'Change Value ' },
          { value: 'significance', label: 'Significance ' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'significance + changeVs', label: 'Significance and Change Value' },

          { value: 'ls', label: 'Low Sample ' },

        ]
      },
      {
        customization: 'Data Label Size# : ', func: 'commonfunc', inputType: 'dropdown', options: [
          { value: '1em', label: '1 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.6em', label: '0.6 em' },
          { value: '1.2em', label: '1.2 em' },
        ]
      },

      { "customization": "Data Label Color : ", "func": "commonfunc", "inputType": "color", "value": "#000000" },
      {
        customization: 'Data Label Position# : ', func: 'commonfunc', inputType: 'dropdown', options: [
          { value: 'center', label: 'Center' },
          { value: 'right', label: 'Left' },
          { value: 'left', label: 'Right' },

        ]
      },
      {
        customization: 'Data Label Position* : ', func: 'commonfunc', inputType: 'dropdown', options: [

          { value: 'Inside Base', label: 'Inside Base' },
          { value: 'Center', label: 'Center' },
          { value: 'Inside End', label: 'Inside End' },
          { value: 'Outside End', label: 'Outside End' }
        ]
      },
    ];
    return custom;
  }
  customizationServiceScatter() {
    let custom: any = [
      { customization: 'Dark Theme', func: 'commonfunc', inputType: 'checkbox', value: 'Dark' },
      { customization: 'GridLines', func: 'commonfunc', inputType: 'checkbox', value: 'gridLines' },

      { customization: 'Shadow', func: 'commonfunc', inputType: 'checkbox', value: 'Shadow' },
      { customization: 'Gradient Bar Color', func: 'commonfunc', inputType: 'checkbox' },
      { customization: 'Hide Axis', func: 'commonfunc', inputType: 'checkbox', value: 'Hide Axis' },
      { customization: 'Axis Image', func: 'commonfunc', inputType: 'checkbox' },
      {
        customization: 'Axis Label Orientation : ', func: 'commonfunc', inputType: 'images', options: [
          { value: 'horizontal', label: 'Horizontal', selected: true, imgClassName: 'axisHorizontal', selectedImgClassName: 'axisHorizontalSelected' },
          { value: 'vertical', label: 'Vertical', selected: false, imgClassName: 'axisVertical', selectedImgClassName: 'axisVerticalSelected' },
          { value: 'angled', label: 'Angled', selected: false, imgClassName: 'axisdiagonalRight', selectedImgClassName: 'axisdiagonalRightSelected' },
        ]
      },
      {
        customization: 'ToolTip Style# : ', func: 'commonfunc', inputType: 'dropdown', options: [
          { value: 'default', label: 'Default' },

          { value: 'style1', label: 'Style1' },
        ]
      },
      {
        customization: 'Marker Style : ', func: 'commonfunc', inputType: 'dropdown', options: [

          { value: 'circle', label: 'Circle' },
          { value: 'square', label: 'Square' },
          { value: 'diamond', label: 'Diamond' },
          { value: 'triangle', label: 'Triangle' }
        ]
      },
      {
        customization: 'Chart Title Position : ', func: 'commonfunc', inputType: 'images', options: [
          { value: 'left', label: 'Left', selected: true, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: false, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ]
      },

      {
        customization: 'Legend : ', func: 'commonfunc', inputType: 'images', options: [
          { value: 'disable', label: 'Disable', selected: true, imgClassName: 'legendDisable', selectedImgClassName: 'legendDisableSelected' },
          { value: 'enable', label: 'Enable', selected: false, imgClassName: 'legendEnable', selectedImgClassName: 'legendEnableSelected' },

        ]
      },
      {
        customization: 'Legend Position : ', func: 'commonfunc', inputType: 'images', options: [

          { value: 'left', label: 'Left', selected: true, imgClassName: 'legendLeft', selectedImgClassName: 'legendLeftSelected' },
          { value: 'bottom', label: 'Bottom', selected: false, imgClassName: 'legendBottom', selectedImgClassName: 'legendBottomSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'legendRight', selectedImgClassName: 'legendRightSelected' },  // Add this option for 'Right'
        ]
      },

      {
        customization: 'Data Label : ', func: 'commonfunc', inputType: 'toggle', options: [

          { value: 'disable', label: 'Off', selected: true },
          { value: 'enable', label: 'On', selected: false },

        ]
      },
      { "customization": "Data Label Color : ", "func": "commonfunc", "inputType": "color", "value": "#000000" },
      {
        customization: 'Data Label Format : ', func: 'commonfunc', inputType: 'images', options: [
          { value: 'number', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ]
      },

      {
        customization: 'Data Label Property : ', func: 'commonfunc', inputType: 'dropdown', options: [
          { value: 'datalabel', label: 'Default ' },
          { value: 'change', label: 'Change Value ' },
          { value: 'significance', label: 'Significance ' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'significance + changeVs', label: 'Significance and Change Value' },

          { value: 'ls', label: 'Low Sample ' },

        ]
      },
      {
        customization: 'Data Label Size# : ', func: 'commonfunc', inputType: 'dropdown', options: [
          { value: '1em', label: '1 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.6em', label: '0.6 em' },
          { value: '1.2em', label: '1.2 em' },
        ]
      },
      {
        customization: 'Data Label Position# : ', func: 'commonfunc', inputType: 'dropdown', options: [
          { value: 'center', label: 'Center' },
          { value: 'right', label: 'Left' },
          { value: 'left', label: 'Right' },

        ]
      },
      {
        customization: 'Data Label Position* : ', func: 'commonfunc', inputType: 'dropdown', options: [

          { value: 'Inside Base', label: 'Inside Base' },
          { value: 'Center', label: 'Center' },
          { value: 'Inside End', label: 'Inside End' },
          { value: 'Outside End', label: 'Outside End' }
        ]
      },
    ];
    return custom;
  }
  commonFunc(customization: any, event: any, property: any) {
    this.properties = property;
    switch (customization) {
      case 'GridLines':
        this.properties.gridlines = event.target.classList.toggle('checked');
        break;
      case 'Shadow':
        this.properties.shadow = event.target.classList.toggle('checked');
        break;
      case 'Dark Theme':
        this.properties.darkTheme = event.target.classList.toggle('checked');
        break;

      case 'Legend : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.showLegend = value === 'enable';
        break;
      case 'ToolTip Style# : ': this.properties.toolTipStyle = event.target.value;

        break



      case 'Legend Position : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.legendPosition = value;

        break;
      case 'Hide Axis':
        this.properties.axisVisible = !event.target.classList.toggle('checked');

        break;
      case 'Axis Label Orientation : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.axisLabelOrientation = value;
        break;
      case 'Chart Title Position : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.chartTitlePosition = value;
        break;
      case 'Gradient Bar Color': this.properties.gradientBarColor = event.target.classList.toggle('checked');
        break;
      case 'Spline': this.properties.line = event.target.classList.toggle('checked');
        break;

      case 'Data Label : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.showDataLabel = value === 'enable'
        break;
      case 'Data Label Color': this.properties.dataLabelColor = event.target.value;
        break;
      case 'Data Label Property : ': this.properties.datalabelStyle = event.target.value;
        break;
      case 'Data Label Position# : ': this.properties.dataLabelPosition = event.target.value;
        break;
      case 'Data Label Format : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.datalabelFormat = value;
        break;
      case 'Data Label Position* : ':

        this.properties.dataLabelPositionPPT = event.target.value;


        break;
      case 'Data Label Size# : ':
        this.properties.dataLabelSize = event.target.value;
        break;
      case 'Data Label Color : ': this.properties.dataLabelColor = event.target.value;

        break;
      case 'Axis Image': this.properties.axisImage = event.target.classList.toggle('checked');
        break;
      case 'Marker : ':
        this.properties.marker = event.target.value;
        break;

      case 'Marker Style : ':
        this.properties.markerStyle = event.target.value;
        break;
      default:

        break;
    }

    return this.properties
  }

  customizationMaps() {
    let custom: any = [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox', className: "", id: 'Dark Theme'
      },
      {
        customization: 'Border',
        func: 'oncheckboxchecked',
        inputType: 'checkbox', className: "", id: 'Border'
      },
      {
        customization: 'ToolTip Style# : ', func: 'oncheckboxchecked', inputType: 'dropdown', className: "", id: 'ToolTip Style# : ', options: [
          { value: 'default', label: 'Default' },
          { value: 'style1', label: 'Style1' },
        ]
      },
      {
        customization: 'Chart Title Position : ', func: 'oncheckboxchecked', inputType: 'images', className: "", id: 'Chart Title Position : ', options: [
          { value: 'left', label: 'Left', selected: false, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: true, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ]
      },
      {
        customization: 'Legend : ', func: 'oncheckboxchecked', inputType: 'images', className: "Legend", id: 'Legend : ', options: [
          { value: 'enable', label: 'Enable', selected: true, imgClassName: 'legendEnable', selectedImgClassName: 'legendEnableSelected' },
          { value: 'disable', label: 'Disable', selected: false, imgClassName: 'legendDisable', selectedImgClassName: 'legendDisableSelected' },
        ]
      },
      {
        customization: 'Position : ', func: 'oncheckboxchecked', inputType: 'images', className: "LegendGrouping", id: 'Legend Position : ', options: [

          { value: 'left', label: 'Left', selected: false, imgClassName: 'legendLeft', selectedImgClassName: 'legendLeftSelected' },
          { value: 'bottom', label: 'Bottom', selected: true, imgClassName: 'legendBottom', selectedImgClassName: 'legendBottomSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'legendRight', selectedImgClassName: 'legendRightSelected' },  // Add this option for 'Right'
        ]
      },
      {
        customization: 'Data Label : ', func: 'oncheckboxchecked', inputType: 'toggle', className: "DataLabel", id: 'Data Label : ', options: [
          { value: 'enable', label: 'On', selected: true },
          { value: 'disable', label: 'Off', selected: false },
        ]
      },
      { "customization": "Color : ", "func": "oncheckboxchecked", "inputType": "color", "value": "#000000", className: "DataLabelGrouping", id: 'Data Label Color : ' },
      {
        customization: 'Format : ', func: 'oncheckboxchecked', inputType: 'images', className: "DataLabelGrouping", id: 'Data Label Format : ', options: [
          { value: 'number', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ]
      },
      {
        customization: 'Property : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown', className: "DataLabelGrouping", id: 'Data Label Property : ',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'changeversus', label: 'Change Versus' },
          {
            value: 'changeversus+significance',
            label: 'Change Versus + Significance',
          },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'ls', label: 'Low Sample' }
        ],
      },
      {
        customization: 'Size# : ', func: 'oncheckboxchecked', inputType: 'dropdown', className: "DataLabelGrouping", id: 'Data Label Size# : ', options: [
          { value: '1em', label: '1 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.7em', label: '0.7 em' },
        ]
      }
    ];
    return custom;
  }

  customizeLegend(chart: any, showlegend: any, legendPos: any, properties: any): Highcharts.LegendOptions {
    let alignLegend: Highcharts.VerticalAlignValue = 'bottom'; // Default value
    let alignx: Highcharts.AlignValue | undefined = 'left';
    let layout1: Highcharts.OptionsLayoutValue | undefined = 'horizontal';

    if (showlegend) {
      switch (legendPos) {
        case "top":
          alignLegend = 'top';
          alignx = 'left';
          layout1 = 'horizontal';
          break;
        case "bottom":
          alignLegend = 'bottom';
          alignx = 'center';
          layout1 = 'horizontal';
          break;
        case "right":
          alignLegend = 'middle';
          alignx = 'right';
          layout1 = 'vertical';
          break;
        case "left":
          alignLegend = 'middle';
          alignx = 'left';
          layout1 = 'vertical';
          break;
        default:
          // No need to change anything for the default case
          break;
      }
    }

    return {
      enabled: properties.showLegend,
      align: alignx,
      verticalAlign: alignLegend,
      layout: layout1,
      itemStyle: {
        color: properties.darkTheme ? "white" : "black",
      },
      itemHiddenStyle: {
        color: "white",
      },


    };
  }
  axisLabelOrientation(axisLabelOrientation: any) {
    let rotationValue = 0;
    switch (axisLabelOrientation) {
      case 'vertical':
        rotationValue = -90; // or 90 depending on your preference
        break;

      case 'horizontal':
        rotationValue = 0;
        break;
      case 'angled':
        rotationValue = 50;
        break;
      case 'diagonal':
        rotationValue = -50;
        break;
      default:
        rotationValue = 0;
        break;
    }
    return rotationValue
  }

  customizeLegendDna(showlegend: any, legendPos: any, properties: any): Highcharts.LegendOptions {
    let alignLegend: Highcharts.VerticalAlignValue = 'bottom'; // Default value
    let alignx: Highcharts.AlignValue | undefined = 'center';
    let layout1: Highcharts.OptionsLayoutValue | undefined = 'horizontal';

    if (showlegend) {
      switch (legendPos) {
        case "bottom":
          alignLegend = 'bottom';
          alignx = 'center';
          layout1 = 'horizontal';
          break;
        case "right":
          alignLegend = 'middle';
          alignx = 'right';
          layout1 = 'vertical';
          break;
        case "left":
          alignLegend = 'middle';
          alignx = 'left';
          layout1 = 'vertical';
          break;
        default:
          showlegend = false
          break;
      }
    }

    return {
      enabled: showlegend,
      align: alignx,
      verticalAlign: alignLegend,
      layout: layout1,
      itemHiddenStyle: {
        color: "gray"
      },
      itemStyle: {
        color: properties.darkTheme ? "white" : "black",
        fontFamily: this.textfont,
        fontWeight: "normal",
        fontSize: "0.9em"
      }
    };
  }

  uniqueChartCustomization: any = {
    funnelchart: [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Dark Theme'
      },
      {
        customization: 'Shadow',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Shadow',
      },
      {
        customization: 'Gradient Bar Color',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Gradient Bar Color',
      },
      {
        customization: 'GridLines',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'GridLines',
      },
      {
        customization: 'PlotBands#',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'PlotBands#',
      },
      {
        customization: 'Horizontal Error Bar',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Horizontal Error Bar',
      },
      {
        customization: 'Border',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Border',
      },
      {
        customization: 'ToolTip Style# : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [
          { value: 'default', label: 'Default' },
          { value: 'style1', label: 'Style1' },
        ], className: "", id: 'ToolTip Style# : ',
      },
      {
        customization: 'Chart Title Position : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'left', label: 'Left', selected: false, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: true, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ], className: "", id: 'Chart Title Position : ',
      },
      {
        customization: 'Data Label : ', func: 'oncheckboxchecked', inputType: 'toggle', options: [

          { value: 'disable', label: 'Off', selected: false },
          { value: 'enable', label: 'On', selected: true },

        ],
        className: "DataLabel",
        id: 'Data Label : '
      },
      {
        "customization": 'Color :', "func": "oncheckboxchecked", "inputType": "color", "value": "#000000",
        className: 'DataLabelGrouping',
        id: 'Data Label Color : ',
      },
      {
        customization: 'Format : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'num', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Format : ',
      },
      {
        customization: 'Property : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'changeversus', label: 'Change Versus' },
          { value: 'changeversus+significance', label: 'Change Versus + Significance' },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'ls', label: 'Low Sample' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Property : ',
      },
      {
        customization: 'Position : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'Center', label: 'Center' },
          { value: 'Inside Base', label: 'Inside Base (Left)' },
          { value: 'Inside End', label: 'Inside End (Right)' },
        ], className: 'DataLabelGrouping',
        id: 'Data Label Position : ',
      },
      {
        customization: 'Size# : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [
          { value: '0.7em', label: '0.7 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '1em', label: '1 em' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Size# : ',
      },
    ],
    waterfallchart1: [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Dark Theme'
      },
      {
        customization: 'Shadow',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Shadow',
      },
      {
        customization: 'Gradient Bar Color',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Gradient Bar Color',
      },

      {
        customization: 'GridLines',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'GridLines',
      },
      {
        customization: 'PlotBands#',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'PlotBands#',
      },
      {
        customization: 'Border',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Border',
      },
      {
        customization: 'Connector',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "Connector", id: 'Connector',
      },
      {
        customization: 'Style : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'Solid', label: 'Solid' },
          { value: 'Dash', label: 'Dash' },
          { value: 'Dot', label: 'Dot' },
        ],
        className: "ConnectorGrouping", id: 'Connector Style : ',
      },
      {
        customization: 'ToolTip Style# : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [
          { value: 'default', label: 'Default' },
          { value: 'style1', label: 'Style1' },
        ], className: "", id: 'ToolTip Style# : '
      },
      {
        customization: 'Chart Title Position : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'left', label: 'Left', selected: false, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: true, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ], className: "", id: 'Chart Title Position : ',
      },
      {
        customization: 'Legend : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'disable', label: 'Disable', selected: false, imgClassName: 'legendDisable', selectedImgClassName: 'legendDisableSelected' },
          { value: 'enable', label: 'Enable', selected: true, imgClassName: 'legendEnable', selectedImgClassName: 'legendEnableSelected' },

        ],
        className: 'Legend',
        id: 'Legend : ',
      },
      {
        customization: 'Position : ', func: 'oncheckboxchecked', inputType: 'images', options: [

          { value: 'left', label: 'Left', selected: false, imgClassName: 'legendLeft', selectedImgClassName: 'legendLeftSelected' },
          { value: 'bottom', label: 'Bottom', selected: false, imgClassName: 'legendBottom', selectedImgClassName: 'legendBottomSelected' },
          { value: 'right', label: 'Right', selected: true, imgClassName: 'legendRight', selectedImgClassName: 'legendRightSelected' },  // Add this option for 'Right'
        ],
        className: 'LegendGrouping',
        id: 'Legend Position : '
      },
      {
        customization: 'Data Label : ', func: 'oncheckboxchecked', inputType: 'toggle', options: [

          { value: 'disable', label: 'Off', selected: false },
          { value: 'enable', label: 'On', selected: true },

        ],
        className: "DataLabel",
        id: 'Data Label : '
      },
      {
        "customization": 'Color :', "func": "oncheckboxchecked", "inputType": "color", "value": "#000000",
        className: 'DataLabelGrouping',
        id: 'Data Label Color : ',
      },
      {
        customization: 'Property : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'changeversus', label: 'Change Versus' },
          { value: 'changeversus+significance', label: 'Change Versus + Significance' },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'ls', label: 'Low Sample' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Property : ',
      },
      {
        customization: 'Size# : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [
          { value: '0.7em', label: '0.7 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '1em', label: '1 em' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Size# : ',
      },
    ],
    waterfallchart2: [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Dark Theme'
      },
      {
        customization: 'Gradient Bar Color#',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Gradient Bar Color',
      },
      // {
      //   customization: 'Pattern',
      //   func: 'oncheckboxchecked',
      //   inputType: 'checkbox',
      // },
      {
        customization: 'GridLines',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'GridLines',
      },
      {
        customization: 'ToolTip Style# : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [
          { value: 'default', label: 'Default' },
          { value: 'style1', label: 'Style1' },
        ], className: "", id: 'ToolTip Style# : '
      },
      {
        customization: 'Chart Title Position : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'left', label: 'Left', selected: false, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: true, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ], className: "", id: 'Chart Title Position : ',
      },
      {
        customization: 'Legend : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'disable', label: 'Disable', selected: false, imgClassName: 'legendDisable', selectedImgClassName: 'legendDisableSelected' },
          { value: 'enable', label: 'Enable', selected: true, imgClassName: 'legendEnable', selectedImgClassName: 'legendEnableSelected' },

        ],
        className: 'Legend',
        id: 'Legend : ',
      },
      {
        customization: 'Position : ', func: 'oncheckboxchecked', inputType: 'images', options: [

          { value: 'left', label: 'Left', selected: false, imgClassName: 'legendLeft', selectedImgClassName: 'legendLeftSelected' },
          { value: 'bottom', label: 'Bottom', selected: false, imgClassName: 'legendBottom', selectedImgClassName: 'legendBottomSelected' },
          { value: 'right', label: 'Right', selected: true, imgClassName: 'legendRight', selectedImgClassName: 'legendRightSelected' },  // Add this option for 'Right'
        ],
        className: 'LegendGrouping',
        id: 'Legend Position : '
      },
      {
        customization: 'Data Label : ', func: 'oncheckboxchecked', inputType: 'toggle', options: [

          { value: 'disable', label: 'Off', selected: false },
          { value: 'enable', label: 'On', selected: true },

        ],
        className: "DataLabel",
        id: 'Data Label : '
      },
      {
        "customization": "Color# : ", "func": "oncheckboxchecked", "inputType": "color", "value": "#000000",
        className: 'DataLabelGrouping',
        id: 'Data Label Color# : ',
      },
      {
        customization: 'Property : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'changeversus', label: 'Change Versus' },
          { value: 'changeversus+significance', label: 'Change Versus + Significance' },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'ls', label: 'Low Sample' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Property : ',
      },
      {
        customization: 'Size# : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [
          { value: '0.7em', label: '0.7 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '1em', label: '1 em' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Size# : ',
      },
      // {
      //   customization: 'Data Label Position : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [
      //     { value: 'Center', label: 'Center' },
      //     { value: 'Inside Base', label: 'Inside Base' },
      //     { value: 'Inside End', label: 'Inside End' }
      //   ]
      // },
    ],
    treemap: [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Dark Theme'
      },
      {
        customization: 'Gradient Bar Color',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Gradient Bar Color',
      },
      {
        customization: 'Border',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Border',
      },
      {
        customization: 'Layout# : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'sliceAndDice', label: 'SliceAndDice' },
          { value: 'squarified', label: 'Squarified' },
          { value: 'stripes', label: 'Stripes' },
          { value: 'strip', label: 'Strip' },
        ],
        className: "", id: 'Layout# : ',
      },
      {
        customization: 'ToolTip Style : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [
          { value: 'default', label: 'Default' },
          { value: 'style1', label: 'Style1' },
        ], className: "", id: 'ToolTip Style# : ',
      },
      {
        customization: 'Chart Title Position : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'left', label: 'Left', selected: false, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: true, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ], className: "", id: 'Chart Title Position : ',
      },
      {
        customization: 'Data Label : ', func: 'oncheckboxchecked', inputType: 'toggle', options: [

          { value: 'disable', label: 'Off', selected: false },
          { value: 'enable', label: 'On', selected: true },

        ],
        className: "DataLabel",
        id: 'Data Label : '
      },
      {
        customization: 'Overlap# : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'disable', label: 'Disable', selected: true, imgClassName: 'labelOverlapDisable', selectedImgClassName: 'labelOverlapDisableSelected' },
          { value: 'enable', label: 'Enable', selected: false, imgClassName: 'labelOverlapEnable', selectedImgClassName: 'labelOverlapEnableSelected' },
        ], className: 'DataLabelGrouping',
        id: 'Data Label Overlap# : '
      },
      {
        "customization": 'Color : ', "func": "oncheckboxchecked", "inputType": "color", "value": "#000000",
        className: 'DataLabelGrouping',
        id: 'Data Label Color : ',
      },
      {
        customization: 'Format# : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'num', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Format# : ',
      },
      {
        customization: 'Property# : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'changeversus', label: 'Change Versus' },
          { value: 'changeversus+significance', label: 'Change Versus + Significance' },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'ls', label: 'Low Sample' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Property# : ',
      },
      {
        customization: 'Data Label Size# : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [
          { value: '0.7em', label: '0.7 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '1em', label: '1 em' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Size# : ',
      },

    ],
    boxplot1: [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Dark Theme'
      },
      {
        customization: 'Marker Style : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'circle', label: 'Circle' },
          { value: 'square', label: 'Square' },
        ], className: "MarkerStyle", id: 'Marker Style : '
      },
      {
        customization: 'Marker Line Style : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'Dash', label: 'Dash' },
          { value: 'Solid', label: 'Solid' },
          { value: 'Dot', label: 'Dot' },
        ],
        className: "MarkerStyleGrouping", id: 'Marker Line Style : '
      },
      {
        customization: 'Chart Style : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'sizeproportion', label: 'Size Proportion' },
        ],
        className: "", id: 'Chart Style : '
      },
      {
        customization: 'ToolTip Style# : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [
          { value: 'default', label: 'Default' },
          { value: 'style1', label: 'Style1' },
        ], className: "", id: 'ToolTip Style# : ',
      },
      {
        customization: 'Chart Title Position : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'left', label: 'Left', selected: false, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: true, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ], className: "", id: 'Chart Title Position : ',
      },
      {
        customization: 'Data Label : ', func: 'oncheckboxchecked', inputType: 'toggle', options: [

          { value: 'disable', label: 'Off', selected: false },
          { value: 'enable', label: 'On', selected: true },

        ],
        className: "DataLabel",
        id: 'Data Label : '
      },
      {
        "customization": 'Color :', "func": "oncheckboxchecked", "inputType": "color", "value": "#000000",
        className: 'DataLabelGrouping',
        id: 'Data Label Color : ',
      },
      {
        customization: 'Format : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'num', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Format : ',
      },
      {
        customization: 'Property : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'changeversus', label: 'Change Versus' },
          { value: 'changeversus+significance', label: 'Change Versus + Significance' },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'ls', label: 'Low Sample' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Property : ',
      },
      {
        customization: 'Size# : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [
          { value: '0.7em', label: '0.7 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '1em', label: '1 em' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Size# : ',
      },
    ],
    boxplot2: [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Dark Theme'
      },
      {
        customization: 'Axis Image',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Axis Image'
      },
      {
        customization: 'GridLines',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'GridLines'
      },
      {
        customization: 'PlotBands#',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'PlotBands#'
      },
      {
        customization: 'PlotLine Style : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'Solid', label: 'Solid' },
          { value: 'Dot', label: 'Dot' },
          { value: 'Dash', label: 'Dash' },
        ],
        className: "", id: 'PlotLine Style : '
      },
      {
        customization: 'Median Dash Style# : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'Solid', label: 'Solid' },
          { value: 'Dot', label: 'Dot' },
          { value: 'Dash', label: 'Dash' },
        ], className: "", id: 'Median Dash Style# : '
      },
      {
        customization: 'Chart Title Position : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'left', label: 'Left', selected: false, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: true, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ], className: "", id: 'Chart Title Position : ',
      },
    ],
    fillchart: [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Dark Theme'
      },
      {
        customization: 'Chart Style : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'style1', label: 'Style1' },
          { value: 'style2', label: 'Style2' },
          { value: 'style3', label: 'Style3' },
          { value: 'style4', label: 'Style4' },
          { value: 'style5', label: 'Style5' },
        ],
        className: "", id: 'Chart Style : '
      },
      {
        customization: 'Fill Color : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'red', label: 'Red' },
          { value: 'pink', label: 'Pink' },
          { value: 'blue', label: 'Blue' },
          { value: 'green', label: 'Green' },
          { value: 'grey', label: 'Grey' },
        ],
        className: "", id: 'Fill Color : '
      },
      {
        customization: 'Fill Direction : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'vertical', label: 'Vertical (Bottom to Top)' },
          { value: 'horizontal', label: 'Horizontal (Left to Right)' },
        ], className: "", id: 'Fill Direction : '
      },
      {
        customization: 'Data Label : ', func: 'oncheckboxchecked', inputType: 'toggle', options: [

          { value: 'disable', label: 'Off', selected: false },
          { value: 'enable', label: 'On', selected: true },

        ],
        className: "DataLabel",
        id: 'Data Label : '
      },
      {
        "customization": 'Color :', "func": "oncheckboxchecked", "inputType": "color", "value": "#000000",
        className: 'DataLabelGrouping',
        id: 'Data Label Color : ',
      },
      {
        customization: 'Format : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'num', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Format : ',
      },
      {
        customization: 'Property : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'changeversus', label: 'Change Versus' },
          { value: 'changeversus+significance', label: 'Change Versus + Significance' },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'ls', label: 'Low Sample' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Property : ',
      },
      {
        customization: 'Size : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [
          { value: '1em', label: '1 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.7em', label: '0.7 em' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Size : ',
      },
    ],
    fillchartwidget1: [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Dark Theme'
      },
      {
        customization: 'Fill To Max',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Fill To Max'
      },
      {
        customization: 'Chart Style : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'style1', label: 'Style1' },
          { value: 'style2', label: 'Style2' },
          { value: 'style3', label: 'Gender Widget' },
        ], className: "", id: 'Chart Style : '
      },
      {
        customization: 'Fill Direction : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'vertical', label: 'Vertical (Bottom to Top)' },
          { value: 'horizontal', label: 'Horizontal (Left to Right)' },
        ], className: "", id: 'Fill Direction : '
      },
      {
        customization: 'Data Label : ', func: 'oncheckboxchecked', inputType: 'toggle', options: [

          { value: 'disable', label: 'Off', selected: false },
          { value: 'enable', label: 'On', selected: true },

        ],
        className: "DataLabel",
        id: 'Data Label : '
      },
      {
        "customization": 'Color :', "func": "oncheckboxchecked", "inputType": "color", "value": "#000000",
        className: 'DataLabelGrouping',
        id: 'Data Label Color : ',
      },
      {
        customization: 'Format : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'num', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Format : ',
      },
      {
        customization: 'Property : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'changeversus', label: 'Change Versus' },
          { value: 'changeversus+significance', label: 'Change Versus + Significance' },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'ls', label: 'Low Sample' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Property : ',
      },
      {
        customization: 'Size : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [
          { value: '1em', label: '1 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.7em', label: '0.7 em' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Size : ',
      },
    ],
    fillchartwidget2: [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "", id: 'Dark Theme'
      },
      {
        customization: 'Chart Style : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'style1', label: 'Style1' },
          { value: 'style2', label: 'Style2' },
          { value: 'style3', label: 'Style3' },
        ], className: "", id: 'Chart Style : '
      },
      {
        customization: 'Fill Color : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'red', label: 'Red' },
          { value: 'pink', label: 'Pink' },
          { value: 'blue', label: 'Blue' },
          { value: 'green', label: 'Green' },
          { value: 'yellow', label: 'Yellow' },
        ], className: "", id: 'Fill Color : '
      },
      {
        customization: 'Fill Direction : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'horizontal', label: 'Horizontal (Left to Right)' },
          { value: 'vertical', label: 'Vertical (Bottom to Top)' },
        ], className: "", id: 'Fill Direction : '
      },
      {
        customization: 'Data Label : ', func: 'oncheckboxchecked', inputType: 'toggle', options: [

          { value: 'disable', label: 'Off', selected: false },
          { value: 'enable', label: 'On', selected: true },

        ],
        className: "DataLabel",
        id: 'Data Label : '
      },
      {
        "customization": 'Color :', "func": "oncheckboxchecked", "inputType": "color", "value": "#000000",
        className: 'DataLabelGrouping',
        id: 'Data Label Color : ',
      },
      {
        customization: 'Format : ', func: 'oncheckboxchecked', inputType: 'images', options: [
          { value: 'num', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Format : ',
      },
      {
        customization: 'Property : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'changeversus', label: 'Change Versus' },
          { value: 'changeversus+significance', label: 'Change Versus + Significance' },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'ls', label: 'Low Sample' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Property : ',
      },
      {
        customization: 'Size : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [
          { value: '1em', label: '1 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.7em', label: '0.7 em' },
        ],
        className: 'DataLabelGrouping',
        id: 'Data Label Size : ',
      },
    ]
  }

  customizationD3Map() {
    let custom: any = [
      {
        customization: 'Border',
        func: 'oncheckboxchecked',
        inputType: 'checkbox', className: "", id: 'Border'
      },
      {
        customization: 'ToolTip Style# : ', func: 'oncheckboxchecked', inputType: 'dropdown', className: "", id: 'ToolTip Style# : ', options: [
          { value: 'default', label: 'Default' },
          { value: 'style1', label: 'Style1' },
        ]
      },
      {
        customization: 'Chart Title Position : ', func: 'oncheckboxchecked', inputType: 'images', className: "", id: 'Chart Title Position : ', options: [
          { value: 'left', label: 'Left', selected: false, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: true, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ]
      },
      {
        customization: 'Data Label : ', func: 'oncheckboxchecked', inputType: 'toggle', className: "DataLabel", id: 'Data Label : ', options: [
          { value: 'disable', label: 'Off', selected: true },
          { value: 'enable', label: 'On', selected: false },

        ]
      },
      { "customization": "Color : ", "func": "oncheckboxchecked", "inputType": "color", "value": "#000000", className: "DataLabelGrouping", id: 'Data Label Color : ' },
      {
        customization: 'Property : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown', className: "DataLabelGrouping", id: 'Data Label Property : ',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'changeversus', label: 'Change Versus' },
          { value: 'changeversus+significance', label: 'Change Versus + Significance' },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'ls', label: 'Low Sample' }
        ],
      },
      {
        customization: 'Size# : ', func: 'oncheckboxchecked', inputType: 'dropdown', className: "DataLabelGrouping", id: 'Data Label Size# : ', options: [
          { value: '1em', label: '1 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.7em', label: '0.7 em' },
        ]
      },
    ];
    return custom;
  }

  customizationDNA() {
    let custom: any = [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox', className: "", id: "Dark Theme"
      },
      {
        customization: 'Marker Style : ', func: 'oncheckboxchecked', inputType: 'dropdown', className: "", id: 'Marker Style : ', options: [
          { value: 'circle', label: 'Circle' },
          { value: 'diamond', label: 'Diamond' },
          { value: 'square', label: 'Square' },
          { value: 'triangle', label: 'Triangle' },
        ]
      },
      {
        customization: 'ToolTip Style# : ', func: 'oncheckboxchecked', inputType: 'dropdown', className: "", id: 'ToolTip Style# : ', options: [
          { value: 'default', label: 'Default' },
          { value: 'style1', label: 'Style1' },
        ]
      },
      {
        customization: 'Chart Title Position : ', func: 'oncheckboxchecked', inputType: 'images', className: "", id: 'Chart Title Position : ', options: [
          { value: 'left', label: 'Left', selected: false, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: true, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ]
      },
      {
        customization: 'Line Style : ', func: 'oncheckboxchecked', inputType: 'dropdown', className: "", id: 'Line Style : ', options: [
          { value: 'Dash', label: 'Dash' },
          { value: 'DashDot', label: 'DashDot' },
          { value: 'Dot', label: 'Dot' },
          { value: 'LongDash', label: 'LongDash' },
          { value: 'LongDashDot', label: 'LongDashDot' },
          { value: 'LongDashDotDot', label: 'LongDashDotDot' },
          { value: 'Solid', label: 'Solid' }
        ]
      },
      {
        customization: 'Line Width# : ', func: 'oncheckboxchecked', inputType: 'dropdown', className: "", id: 'LineWidth', options: [
          { value: 2.5, label: '2.5' },
          { value: 3, label: '3' },
          { value: 3.5, label: '3.5' },
          { value: 2, label: '2' },
          { value: 1.5, label: '1.5' },
          { value: 1, label: '1' },
        ]
      },
      {
        customization: 'Legend : ', func: 'oncheckboxchecked', inputType: 'images', className: "Legend", id: 'Legend : ', options: [
          { value: 'enable', label: 'Enable', selected: true, imgClassName: 'legendEnable', selectedImgClassName: 'legendEnableSelected' },
          { value: 'disable', label: 'Disable', selected: false, imgClassName: 'legendDisable', selectedImgClassName: 'legendDisableSelected' },
        ]
      },
      {
        customization: 'Position : ', func: 'oncheckboxchecked', inputType: 'images', className: "LegendGrouping", id: 'Legend Position : ', options: [
          { value: 'left', label: 'Left', selected: false, imgClassName: 'legendLeft', selectedImgClassName: 'legendLeftSelected' },
          { value: 'bottom', label: 'Bottom', selected: true, imgClassName: 'legendBottom', selectedImgClassName: 'legendBottomSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'legendRight', selectedImgClassName: 'legendRightSelected' },  // Add this option for 'Right'
        ]
      },
      {
        customization: 'Data Label : ', func: 'oncheckboxchecked', inputType: 'toggle', className: "DataLabel", id: 'Data Label : ', options: [
          { value: 'enable', label: 'On', selected: true },
          { value: 'disable', label: 'Off', selected: false },
        ]
      },
      { "customization": "Color : ", "func": "oncheckboxchecked", "inputType": "color", "value": "#000000", className: "DataLabelGrouping", id: 'Data Label Color : ' },
      {
        customization: 'Format : ', func: 'oncheckboxchecked', inputType: 'images', className: "DataLabelGrouping", id: 'Data Label Format : ', options: [
          { value: 'number', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ]
      },
      {
        customization: 'Property : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown', className: "DataLabelGrouping", id: 'Data Label Property : ',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'change', label: 'Change Versus' },
          { value: 'sigchan', label: 'Change Versus + Significance' },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'lowSample', label: 'Low Sample' },
        ],
      },
      {
        customization: 'Size# : ', func: 'oncheckboxchecked', inputType: 'dropdown', className: "DataLabelGrouping", id: 'Data Label Size# : ', options: [
          { value: '1em', label: '1 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.7em', label: '0.7 em' },
        ]
      },
    ];
    return custom;
  }

  customizationSankey() {
    let custom: any = [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox', className: "", id: 'Dark Theme'
      },
      {
        customization: 'Border',
        func: 'oncheckboxchecked',
        inputType: 'checkbox', className: "", id: 'Border'
      },
      {
        customization: 'ToolTip Style : ', func: 'oncheckboxchecked', inputType: 'dropdown', className: "", id: 'ToolTip Style : ', options: [
          { value: 'default', label: 'Default' },
          { value: 'style1', label: 'Style1' },
        ]
      },
      {
        customization: 'Chart Title Position : ', func: 'oncheckboxchecked', inputType: 'images', className: '', id: 'Chart Title Position : ', options: [
          { value: 'left', label: 'Left', selected: false, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: true, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ]
      },
      {
        customization: 'Data Label : ', func: 'oncheckboxchecked', inputType: 'toggle', className: 'DataLabel', id: 'Data Label : ', options: [
          { value: 'enable', label: 'On', selected: true },
          { value: 'disable', label: 'Off', selected: false },
        ]
      },
      { "customization": "Color : ", "func": "oncheckboxchecked", "inputType": "color", "value": "#000000", className: 'DataLabelGrouping', id: 'Data Label Color : ' },
      {
        customization: 'Format : ', func: 'oncheckboxchecked', inputType: 'images', className: 'DataLabelGrouping', id: 'Data Label Format : ', options: [
          { value: 'num', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ]
      },
      {
        customization: 'Property : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown', className: 'DataLabelGrouping', id: 'Data Label Property : ',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'change', label: 'Change Versus' },
          { value: 'sigchan', label: 'Change Versus + Significance' },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'lowSample', label: 'Low Sample' },
        ],
      },
      {
        customization: 'Size# : ', func: 'oncheckboxchecked', inputType: 'dropdown', className: 'DataLabelGrouping', id: 'Data Label Size# : ', options: [
          { value: '1em', label: '1 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.7em', label: '0.7 em' },
        ]
      },
    ];
    return custom;
  }

  customizationWord() {
    let custom: any = [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox', className: "", id: 'Dark Theme'
      },
      {
        customization: 'Data from : ', func: 'oncheckboxchecked', inputType: 'dropdown', className: "", id: 'Data from : ', options: [
          { value: 'text', label: 'Text' },
          { value: 'json', label: 'Json' },
        ]
      },
      {
        customization: 'ToolTip Style# : ', func: 'oncheckboxchecked', inputType: 'dropdown', className: "", id: 'ToolTip Style : ', options: [
          { value: 'default', label: 'Default' },
          { value: 'style1', label: 'Style1' },
        ]
      },
      {
        customization: 'Chart Title Position : ', func: 'oncheckboxchecked', inputType: 'images', className: "", id: 'Chart Title Position : ', options: [
          { value: 'left', label: 'Left', selected: false, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: true, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ]
      },
    ];
    return custom;
  }



  applycustomization(event: any, item: any, properties: any) {
    this.commonchartmodules.applycustomization(event, item, properties)
  }

  customization() {
    let custom: any = [
      {
        customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '', options: this._configService.clientSnapshotAllStudyNames
      },
      {
        customization: 'Metric : ', func: 'applycustomization', inputType: 'checkboxlist', className: '', id: '', select: 2, options: [
          { value: 'metric1', label: 'Metric 1' }, { value: 'metric2', label: 'Metric 2' }, { value: 'metric3', label: 'Metric 3' }, { value: 'metric4', label: 'Metric 4' },
        ]
      },
      {
        customization: 'Widget Name : ', func: 'applycustomization', inputType: 'text', className: '', id: ''
      },
      {
        customization: 'Decimal Round Off : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: '',
        id: 'Decimal Round Off',
        options: [{ value: 0, label: 'None' },
        { value: 1, label: 'One Decimal Point' },
        { value: 2, label: 'Two Decimal Point' }],
      },
      {
        customization: 'Info Button : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: '',
        id: '',
        options: [{ value: 'none', label: 'None' }],
      },
      {
        customization: 'Data Label : ',
        func: 'applycustomization',
        inputType: 'toggle',
        className: 'DataLabel',
        id: 'Data Label',
        options: [
          { value: 'enable', label: 'On', selected: true },
          { value: 'disable', label: 'Off', selected: false },
        ],
      },
      {
        customization: 'Color : ',
        func: 'applycustomization',
        inputType: 'color',
        className: 'DataLabelGrouping',
        id: 'Data Label Color',
        value: '#000000',
      },

      {
        customization: 'Property : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: 'DataLabelGrouping',
        id: 'Data Label Property',
        options: [
          { value: 'datalabel', label: 'Default ' },
          { value: 'change', label: 'Change Versus ' },
          {
            value: 'significance + changeVs',
            label: 'Change Versus + Significance',
          },

          { value: 'significance', label: 'Significance ' },
          { value: 'significance2', label: 'Significance Level2' },

          { value: 'ls', label: 'Low Sample ' },
        ],
      },

      {
        customization: 'Size : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: 'DataLabelGrouping',
        id: 'Data Label Size',
        options: [
          { value: '1em', label: '1 Em' },
          { value: '0.9em', label: '0.9 Em' },
          { value: '0.8em', label: '0.8 Em' },
          { value: '0.7em', label: '0.7 Em' },
        ],
      },
      {
        customization: 'Position : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: 'DataLabelGrouping',
        id: 'Data Label Position',
        options: [
          { value: 'Center', label: 'Center' },
          { value: 'Inside Base', label: 'Left' },
          { value: 'Inside End', label: 'Right' },
        ],
      },
    ];
    custom = [...custom];

    return custom;
  }
  list: any
  FunnelChartCustomizationList(): Observable<any[]> {
    return this.commonchartmodules.getCustomization().pipe(
      map(data => {
        this.list = JSON.parse(data);
        this.list = this.list.filter((item: any) => item.Chart.trim() == "Funnel Chart")
        let custom: any[] = [];
        custom.push({
          customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',
          options: this._configService.clientSnapshotAllStudyNames
        });
        if (this.list[0].MetricDropDownWithoutAxis) custom.push(this.commonchartmodules.customizationObject.NumberOfMetricVisible(this.list[0].NumberOfMetricVisible));
        custom.push(this.commonchartmodules.customizationObject.WidgetName);
        if (this.list[0].Xaxis) custom.push(this.commonchartmodules.customizationObject.XAxis);
        if (this.list[0].Yaxis) custom.push(this.commonchartmodules.customizationObject.YAxis);
        if (this.list[0].ZAxis) custom.push(this.commonchartmodules.customizationObject.ZAxis);
        if (this.list[0].XAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.XAxisLabelOrientation);
        if (this.list[0].YAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.YAxisLabelOrientation);
        if (this.list[0].ZAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.ZAxisLabelOrientation);
        custom = [...custom, ...this.commonchartmodules.commoncustomizationlist().slice(0, this.commonchartmodules.commoncustomizationlist().length - 1)]
        custom.push({
          customization: 'Position : ',
          func: 'applycustomization',
          inputType: 'dropdown',
          className: 'DataLabelGrouping',
          id: 'Data Label Position',
          options: [
            { value: 'Center', label: 'Center' },
            { value: 'Inside Base', label: 'Left' },
            { value: 'Inside End', label: 'Right' },
          ],
        },)
        return custom;
      })
    );
  }
}
